if (!customElements.get('buy-it-with-slider')) {
  customElements.define('buy-it-with-slider', class BuyItWithSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.carousel = this.querySelector('.buy-it-with-grid');
      this.initialize();
    }

    initialize() {
      if (!this.carousel) return;

      const enableLoop = this.getAttribute('data-loop') === 'true';

      // Ensure the grid is block before init to avoid FOUC
      this.carousel.style.display = 'block';

      this.flickity = new Flickity(this.carousel, {
        cellAlign: 'left',
        contain: true,
        draggable: true,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: false,
        accessibility: false,
        groupCells: false,
        selectedAttraction: 0.02,
        friction: 0.4,
        cellSelector: '.buy-it-with-item'
      });
    }
  });
}

if (!customElements.get('buy-it-with-navigation')) {
  customElements.define('buy-it-with-navigation', class BuyItWithNavigation extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init(retry = 1, maxRetry = 8) {
      if (retry === maxRetry) return;

      const id = this.getAttribute('for');
      this.carouselComponent = document.querySelector(`#${id}`);

      if ((!this.carouselComponent || !this.carouselComponent.flickity)) {
        setTimeout(() => this.init(retry + 1), 250);
        return;
      }

      this.flickity = this.carouselComponent.flickity;
      this.buttonPrev = this.querySelector('.js-prev');
      this.buttonNext = this.querySelector('.js-next');

      if (this.buttonPrev) {
        this.buttonPrev.addEventListener('click', (e) => {
          e.preventDefault();
          this.flickity.previous();
        });
      }
      if (this.buttonNext) {
        this.buttonNext.addEventListener('click', (e) => {
          e.preventDefault();
          this.flickity.next();
        });
      }

      this.flickity.on('select', () => {
        this.enableButton(this.buttonPrev);
        this.enableButton(this.buttonNext);
        if (!this.flickity.slides[this.flickity.selectedIndex - 1]) {
          this.disableButton(this.buttonPrev);
        } else if (!this.flickity.slides[this.flickity.selectedIndex + 1]) {
          this.disableButton(this.buttonNext);
        }
      });
    }

    enableButton(button) {
      if (!button) return;
      button.classList.remove('pill-nav-item-disabled');
      button.classList.remove('focus-none');
      button.removeAttribute('aria-disabled');
      button.removeAttribute('disabled');

    }

    disableButton(button) {
      if (!button) return;
      button.classList.add('pill-nav-item-disabled');
      button.classList.add('focus-none');
      button.removeAttribute('aria-disabled');
      button.setAttribute('disabled', 'true');
      button.setAttribute('aria-disabled', 'true');
    }
  });
}


